import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { StartGradingSessionResult } from "../../types/grading/PendingCorrection";

export const useStartGradingSession = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation<StartGradingSessionResult, Error, string>({
    mutationFn: async (examInstanceId: string) => {
      const response = await axios.post<StartGradingSessionResult>(
        `/api/grading/examinstances/${examInstanceId}/start`
      );
      return response.data;
    },
    onSuccess: (_, examInstanceId) => {
      // Invalidate the pending corrections list to update status/locks
      queryClient.invalidateQueries({ queryKey: ["pendingCorrections"] });
      // Also invalidate lock status if used elsewhere
      queryClient.invalidateQueries({ queryKey: ["gradingLockStatus", examInstanceId] });
      // And grading summary
      queryClient.invalidateQueries({ queryKey: ["gradingSummary", examInstanceId] });
    },
  });
};

export default useStartGradingSession;
